(() => {
  const templateId = 'ProductStoreLocatorButtonTemplate';

  const addToCartSelector =
    '.cpb-product-actions-container .cpb-add-to-cart-button';

  function insertStoreLocatorButtons() {
    const template = document.getElementById(templateId);

    if (!template || !template.content) return;

    document.querySelectorAll(addToCartSelector).forEach((addToCartButton) => {
      const container = addToCartButton.closest(
        '.cpb-product-actions-container'
      );

      if (!container) return;

      const existingButton = container.querySelector(
        '.product-store-locator-button'
      );

      /*
       * The product builder can rerender its controls. If our button still
       * exists but is no longer directly below Add to Cart, move it back.
       */
      if (existingButton) {
        if (addToCartButton.nextElementSibling !== existingButton) {
          addToCartButton.insertAdjacentElement(
            'afterend',
            existingButton
          );
        }

        return;
      }

      const renderedSnippet = template.content.cloneNode(true);

      const storeLocatorButton = renderedSnippet.querySelector(
        '.product-store-locator-button'
      );

      /*
       * The snippet returns no button when the product has no recognized
       * brand tag.
       */
      if (!storeLocatorButton) return;

      addToCartButton.insertAdjacentElement(
        'afterend',
        storeLocatorButton
      );
    });
  }

  function initializeStoreLocatorButton() {
    insertStoreLocatorButtons();

    /*
     * Custom Product Builder renders asynchronously and may rerender when
     * the configuration changes.
     */
    const observer = new MutationObserver(insertStoreLocatorButtons);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeStoreLocatorButton
    );
  } else {
    initializeStoreLocatorButton();
  }
})();